export default __webpack_public_path__ + "static/media/starmask.ccab1708.png";